import React from 'react';
import './Table.css';

export interface TableColumn<T> {
  label: string;
  key: keyof T;
  sortable?: boolean;
  render?: (row: T) => React.ReactNode;
}

interface TableProps<T> {
  columns: TableColumn<T>[];
  rows: T[];
  footer?: React.ReactNode; // <-- New footer prop
  onRowClick?: (row: T) => void;
  clickableRows?: boolean;
}

export function Table<T extends Record<string, any>>({
  columns,
  rows,
  footer,
  onRowClick,
  clickableRows = false,
}: TableProps<T>) {
  return (
    <div className="table-container">
      <table className="custom-table">
        <thead>
          <tr>
            {columns.map((col, index) => (
              <th
                key={index}
                style={col.key === 'points' ? { textAlign: 'right' } : undefined}
              >
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr 
              key={rowIndex}
              className={clickableRows ? 'clickable-row' : ''}
              onClick={() => clickableRows && onRowClick && onRowClick(row)}
              style={{
                cursor: clickableRows ? 'pointer' : 'default'
              }}
            >
              {columns.map((col, colIndex) => (
                <td
                  key={colIndex}
                  style={col.key === 'points' ? { textAlign: 'right' } : undefined}
                >
                  {col.render ? col.render(row) : (row[col.key] as any)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
        {footer && (
          <tfoot>
            <tr>
              <td colSpan={columns.length} className="table-footer">
                {footer}
              </td>
            </tr>
          </tfoot>
        )}
      </table>
    </div>
  );
}

// Add this to ensure it's a module for isolatedModules
export {};
